<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-content--scrollable">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Diluir mensalidade
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <table class="table table-striped">
            <caption>Mensalidade para ser diluída</caption>
            <thead>
              <th>Id</th>
              <th>Status</th>
              <th>Data de vencimento</th>
              <th>Valor</th>
              <th>Valor com encargos</th>
            </thead>
            <tbody>
              <td>{{ selectedBill.id }}</td>
              <td>{{ selectedBill.translated_status }}</td>
              <td>{{ selectedBill.due_date | formatDate }}</td>
              <td>{{ selectedBill.amount | formatCurrency }}</td>
              <td>{{ selectedBill.amount_with_charges | formatCurrency }}</td>
            </tbody>
          </table>
          <div v-if="inputError" class="alert alert-danger">
            {{ inputError }}
          </div>
          <p class="modal-legend">
            A diluição remove encargos por atraso e divide o valor da mensalidade
            dentre as demais selecionadas. Só é possível diluir uma mensalidade por vez
          </p>
          <table class="table table-striped">
            <caption>Parcelas para receber o valor</caption>
            <thead>
              <th></th>
              <th>Vencimento</th>
              <th>Valor atual</th>
              <th>Novo valor<br>(aproximado)</th>
            </thead>
            <tbody>
              <tr v-for="billToReceiveValue in bills" :key="billToReceiveValue.id">
                <td>
                  <input v-model="selectedBillsIds" :value="billToReceiveValue.id" type="checkbox">
                </td>
                <td>{{ billToReceiveValue.due_date | formatDate }}</td>
                <td>{{ billToReceiveValue.amount | formatCurrency }}</td>
                <td>{{ calculateNewValue(billToReceiveValue) | formatCurrency }}</td>
              </tr>
              <tr>
                <th colspan="3">
                  Valor para adicionar às mensalidades (aproximado)
                </th>
                <td>{{ newBillsValue | formatCurrency }}</td>
              </tr>
            </tbody>
          </table>
          <p>Observação para o cancelamento (ex: Diluída mensalidade x para as y e z por acordo com o aluno)</p>
          <input @click="inputError = null" class="form-input" type="text" v-model="observations">
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="applyDilution">
            Salvar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BillsService from 'services/BillsService';

export default {
  data() {
    return {
      selectedBillsIds: [],
      observations: null,
      inputError: null,
    };
  },
  computed: {
    ...mapState([
      'selectedBill',
      'studentBills',
    ]),
    bills() {
      return this.studentBills
        .filter(bill => bill.id !== this.selectedBill.id && bill.contract_id === this.selectedBill.contract_id
          && bill.status === 'open');
    },
    newBillsValue() {
      return (parseFloat(this.selectedBill.amount_with_charges) / (this.selectedBillsIds.length || 1));
    },
  },
  created() {
    this.selectedBillsIds = this.bills.map(bill => bill.id);
  },
  watch: {
    selectedBillsIds() {
      this.inputError = null;
    },
  },
  methods: {
    ...mapActions([
      'loadStudentBills',
    ]),
    calculateNewValue(bill) {
      if (this.selectedBillsIds.includes(bill.id)) return bill.amount + this.newBillsValue;
      return bill.amount;
    },
    validate() {
      if (this.selectedBillsIds.length < 2) {
        this.inputError = 'Pelo menos outras duas mensalidade devem, ser selecionada para aplicar a diluição';
        return false;
      }
      if (!this.observations) {
        this.inputError = 'É necessário especificar uma observação para a diluição';
        return false;
      }
      return true;
    },
    applyDilution() {
      if (!this.validate()) {
        return;
      }

      this.$loader.show();
      BillsService.diluteBill(this.selectedBill.id, this.selectedBillsIds, this.observations)
        .then(() => {
          this.loadStudentBills();
          this.$alert.notifySuccess('Diluição efetuada com sucesso');
          this.$emit('close');
        })
        .catch(({ body }) => {
          this.inputError = `Erro ao fazer a diluição: ${body.message}`;
        })
        .finally(() => this.$loader.hide());
    },
  },
};
</script>
